module.exports = __webpack_public_path__ + "static/media/success_4.c815396f.gif";